



















































import { Vue, Prop, Component, Watch, Inject } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { submitWork } from "@/services/api/submission";
import LoaderMixin from "@/mixins/loader";
import NotificationMixin from "@/mixins/notification";

@Component
export default class SubmissionForm extends mixins(
  LoaderMixin,
  NotificationMixin
) {
  private dialog: boolean = false;
  private valid: boolean = false;

  private fileName: string = "";
  private fileUrl: string = "";
  private file: File = null;

  private title: string = "";

  constructor() {
    super();
  }

  private pickFile() {
    // @ts-ignore
    this.$refs.image.click();
  }

  private onFilePicked(e: any) {
    const files = e.target.files;
    if (files[0] !== undefined) {
      this.fileName = files[0].name;
      if (this.fileName.lastIndexOf(".") <= 0) {
        return;
      }
      const fr = new FileReader();
      fr.readAsDataURL(files[0]);
      fr.addEventListener("load", () => {
        this.fileUrl = fr.result as string;
        this.file = files[0]; // this is an image file that can be sent to server...
      });
    } else {
      this.fileName = "";
      this.file = null;
      this.fileUrl = "";
    }
  }

  private async submit() {
    //@ts-ignore
    if (this.$refs.form.validate()) {
      if (this.fileName.includes(".pdf")) {
        if (new Date() < new Date("11/06/2019")) {
          this.showLoader();
          submitWork(this.$store.state.user.id, this.title, this.file)
            .then(result => {
              if (result.success) {
                this.hideLoader();
                this.dialog = false;
                this.$emit("submissionCompleted");
              }
            })
            .catch(err => {
              this.hideLoader();
              this.showServerErorNotification();
            });
        } else {
          this.showWarningNotification("As submissões foram encerradas.");
        }
      } else {
        this.showErrorNotification("Somente arquivos .pdf são permitidos.");
      }
    }
  }
}
